export const GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA'
export const GET_ACCOUNT_LINES = 'GET_ACCOUNT_LINES'
export const GET_TYPES = 'GET_TYPES'
export const GET_TROUBLE_TICKET_HISTORY = 'GET_TROUBLE_TICKET_HISTORY'
export const GET_ACCOUNT_INVOICES = 'GET_ACCOUNT_INVOICES'
export const GET_BILLS_DETAILS = 'GET_BILLS_DETAILS'
export const GET_ORDERS = 'GET_ORDERS'
export const GET_BARRING_SERVICES = 'GET_BARRING_SERVICES'
